import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

/**
 * RemoveButton Component
 *
 * A shared remove/close button used across card components.
 * Provides consistent styling and accessibility for remove actions.
 *
 * Props:
 * @param {Function} onClick - Handler for click event
 * @param {string} title - Button title for tooltip (default: "Remove from board")
 * @param {string} ariaLabel - Accessible label (default: same as title)
 * @param {string} className - Additional CSS classes to apply
 */
const RemoveButton = ({
  onClick,
  title,
  ariaLabel,
  className = ''
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('removeButton.titleDefault');
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
      className={`absolute top-2 right-2 z-raised inline-flex items-center justify-center p-1.5 min-w-[44px] min-h-[44px] sm:min-w-0 sm:min-h-0 sm:p-1.5 bg-content-inverse/90 backdrop-blur-sm text-content-muted hover:text-error hover:bg-error-light rounded-full shadow-sm transition-all duration-normal focus-visible:outline-2 focus-visible:outline-error focus-visible:outline-offset-2 ${className}`}
      title={resolvedTitle}
      aria-label={ariaLabel || resolvedTitle}
    >
      <Icon name="close" className="w-4 h-4" />
    </button>
  );
};

export default React.memo(RemoveButton);
